module.exports = __webpack_public_path__ + "img/sun-with-face.59fd3685.png";